module.exports = __webpack_public_path__ + "img/_4.d3a20ddf.png";